import { initSubRoutes } from '../../../../utils/router';

const RoutesModifierResponsableLegal = initSubRoutes({
    route: '/modifier-responsable-legal/',
    subroutes: {},
    nom: 'Modification des informations du responsable légal',
});

export default RoutesModifierResponsableLegal;
